import { Checkbox, FormControlLabel } from '@mui/material';
import { useField } from 'formik';
import React, { FC } from 'react';
import toast from 'react-hot-toast';

export const FormikCheckboxField: FC<{ name: string; label: string }> = props => {
  const [, meta, helpers] = useField<boolean | undefined | null>(props.name);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    helpers.setValue(event.target.checked);
    if (props.label === 'Archiviert') {
      const value = Boolean(meta.value);
      if (value) {
        toast.success('Projekt erfolgreich aktiviert!');
      } else {
        toast.success('Projekt erfolgreicht archiviert!');
      }
    }
  };

  return (
    <FormControlLabel
      control={<Checkbox checked={Boolean(meta.value)} onChange={handleChange} />}
      label={props.label}
    />
  );
};
